// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Otherinfo_basicinfo__wrZCt {
  width: 661px;
  min-height: 250px;
  padding: 25px;
  background-color: white;
  border-radius: 20px;
  box-shadow: 5px 5px 10px #d5d5d5, -5px -5px 10px #ebebeb;
  margin-top: 40px;
  margin-bottom: 50px;
}
.Otherinfo_infoDetals__iAcqw {
  display: flex;
  justify-content: space-between;
}
.Otherinfo_infoHead__Dyoqx {
  font-size: 20px;
  font-weight: bold;
}
.Otherinfo_EditButton__73vgx {
  position: relative;
  width: 36px;
  height: 36px;
  background-color: #efeeed;
  border-radius: 50px;
  padding: 50px 10px;
  cursor: pointer;
}
.Otherinfo_EditButton__73vgx img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.Otherinfo_BasicDetails__p3AjV {
  padding-top: 10px;
  word-break: break-word;
}
.Otherinfo_EditDetails__U9EST {
  padding-top: 20px;
}
.Otherinfo_EditDetails__U9EST label {
    font-weight: 700;
  }
.Otherinfo_EditInputfeild__ZlCAs {
  width: 590px;
  margin: auto;
  margin-bottom: 20px;
}
.Otherinfo_EditSelectFeild__6ELPf {
  width: 100%;
  background-color: white;
  border-radius: 50px;
  border: 2px solid grey;
  font-size: 16px;
  padding: 11px;
}
.Otherinfo_EditSubSelectFeild__X7veL {
  width: 30%;
  background-color: white;
  border-radius: 50px;
  border: 2px solid grey;
  font-size: 16px;
  padding: 11px;
  margin-right: 15px;
}
.Otherinfo_EditInputfeild__ZlCAs input {
  width: 100%;
  border-radius: 50px;
  border: 2px solid grey;
  font-size: 16px;
  padding: 11px;
  padding-left: 18px;

}
.Otherinfo_EditName__jf\\+fB {
  display: block;
  margin-left: 20px;
}
.Otherinfo_EditTextfeild__3KcM- {
  width: 590px;
  margin: auto;
  margin-bottom: 20px;
}
.Otherinfo_EditTextfeild__3KcM- textarea {
  width: 100%;
  border-radius: 20px;
  border: 2px solid grey;
  font-size: 16px;
  padding: 11px;
}
.Otherinfo_SaveCancelButtonContainer__DYUdq{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.Otherinfo_cancelButton__F6NJB{
  width: 88px;
  height:33px;
  border:none;
  border-radius:20px; 
  background-color: transparent;
  cursor: pointer;
  outline: none !important;
}
.Otherinfo_SaveButton__08qTr {
  width: 88px;
  height: 33px;
  border: none;
  border-radius: 20px;
  background: linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%);

  color: white;
  cursor: pointer;
}
.Otherinfo_errorMsg__BM1co {
  visibility: visible;
  margin: 0px;
  padding-top: 5px;
  font-size: 12px;
  color: rgb(230, 79, 79);
  margin-left: 15px;
}`, "",{"version":3,"sources":["webpack://./src/pages/EditProfile/Otherinfo/Otherinfo.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wDAAwD;EACxD,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EAGT,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;IACI,gBAAgB;EAClB;AACF;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;AACA;EACE,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,kBAAkB;;AAEpB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,0EAA0E;;EAE1E,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,iBAAiB;AACnB","sourcesContent":[".basicinfo {\r\n  width: 661px;\r\n  min-height: 250px;\r\n  padding: 25px;\r\n  background-color: white;\r\n  border-radius: 20px;\r\n  box-shadow: 5px 5px 10px #d5d5d5, -5px -5px 10px #ebebeb;\r\n  margin-top: 40px;\r\n  margin-bottom: 50px;\r\n}\r\n.infoDetals {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.infoHead {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n}\r\n.EditButton {\r\n  position: relative;\r\n  width: 36px;\r\n  height: 36px;\r\n  background-color: #efeeed;\r\n  border-radius: 50px;\r\n  padding: 50px 10px;\r\n  cursor: pointer;\r\n}\r\n.EditButton img {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  -webkit-transform: translate(-50%, -50%);\r\n  -ms-transform: translate(-50%, -50%);\r\n  transform: translate(-50%, -50%);\r\n}\r\n.BasicDetails {\r\n  padding-top: 10px;\r\n  word-break: break-word;\r\n}\r\n.EditDetails {\r\n  padding-top: 20px;\r\n}\r\n.EditDetails label {\r\n    font-weight: 700;\r\n  }\r\n.EditInputfeild {\r\n  width: 590px;\r\n  margin: auto;\r\n  margin-bottom: 20px;\r\n}\r\n.EditSelectFeild {\r\n  width: 100%;\r\n  background-color: white;\r\n  border-radius: 50px;\r\n  border: 2px solid grey;\r\n  font-size: 16px;\r\n  padding: 11px;\r\n}\r\n.EditSubSelectFeild {\r\n  width: 30%;\r\n  background-color: white;\r\n  border-radius: 50px;\r\n  border: 2px solid grey;\r\n  font-size: 16px;\r\n  padding: 11px;\r\n  margin-right: 15px;\r\n}\r\n.EditInputfeild input {\r\n  width: 100%;\r\n  border-radius: 50px;\r\n  border: 2px solid grey;\r\n  font-size: 16px;\r\n  padding: 11px;\r\n  padding-left: 18px;\r\n\r\n}\r\n.EditName {\r\n  display: block;\r\n  margin-left: 20px;\r\n}\r\n.EditTextfeild {\r\n  width: 590px;\r\n  margin: auto;\r\n  margin-bottom: 20px;\r\n}\r\n.EditTextfeild textarea {\r\n  width: 100%;\r\n  border-radius: 20px;\r\n  border: 2px solid grey;\r\n  font-size: 16px;\r\n  padding: 11px;\r\n}\r\n.SaveCancelButtonContainer{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n.cancelButton{\r\n  width: 88px;\r\n  height:33px;\r\n  border:none;\r\n  border-radius:20px; \r\n  background-color: transparent;\r\n  cursor: pointer;\r\n  outline: none !important;\r\n}\r\n.SaveButton {\r\n  width: 88px;\r\n  height: 33px;\r\n  border: none;\r\n  border-radius: 20px;\r\n  background: linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%);\r\n\r\n  color: white;\r\n  cursor: pointer;\r\n}\r\n.errorMsg {\r\n  visibility: visible;\r\n  margin: 0px;\r\n  padding-top: 5px;\r\n  font-size: 12px;\r\n  color: rgb(230, 79, 79);\r\n  margin-left: 15px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"basicinfo": `Otherinfo_basicinfo__wrZCt`,
	"infoDetals": `Otherinfo_infoDetals__iAcqw`,
	"infoHead": `Otherinfo_infoHead__Dyoqx`,
	"EditButton": `Otherinfo_EditButton__73vgx`,
	"BasicDetails": `Otherinfo_BasicDetails__p3AjV`,
	"EditDetails": `Otherinfo_EditDetails__U9EST`,
	"EditInputfeild": `Otherinfo_EditInputfeild__ZlCAs`,
	"EditSelectFeild": `Otherinfo_EditSelectFeild__6ELPf`,
	"EditSubSelectFeild": `Otherinfo_EditSubSelectFeild__X7veL`,
	"EditName": `Otherinfo_EditName__jf+fB`,
	"EditTextfeild": `Otherinfo_EditTextfeild__3KcM-`,
	"SaveCancelButtonContainer": `Otherinfo_SaveCancelButtonContainer__DYUdq`,
	"cancelButton": `Otherinfo_cancelButton__F6NJB`,
	"SaveButton": `Otherinfo_SaveButton__08qTr`,
	"errorMsg": `Otherinfo_errorMsg__BM1co`
};
export default ___CSS_LOADER_EXPORT___;
